module.exports = __webpack_public_path__ + "img/5m.ccf628ba.png";